import { ManagerInvitationsAccept } from "./Accept";

export const pages = {
  "manager-invitations.accept": ManagerInvitationsAccept,
};
